/**
 * plugins/app.js
 *
 * Automatically loads and bootstraps files
 * in the `./src/components/` folder.
 */

// Imports
import Vue from 'vue'

const requireComponent = require.context('@/components', true, /\.vue$/)

for (const file of requireComponent.keys()) {
  const componentConfig = requireComponent(file)
  const component = componentConfig.default || componentConfig

  // Skip component registration if no name is provided
  if (component.name) {
    Vue.component(
      component.name,
      component
    )
  }
}

import '@/filters'

